window.addEventListener('DOMContentLoaded', function (e) {
	if (window.innerWidth < 1200) {
		document.querySelectorAll('li.parent').forEach(toggleMenu)
		function toggleMenu(el) {
			// let link = el.querySelector('.mobile-arrow-down')
			let link = el

			link.onclick = function () {
				const isExpanded = el.classList.contains('expanded')

				document.querySelectorAll('li.parent').forEach(li => {
					li.classList.remove('expanded')
				})

				el.classList.toggle('expanded', !isExpanded)
			}
		}
	}

	window.addEventListener('resize', e => {
		if (window.innerWidth < 1200) {
			document.querySelectorAll('li.parent').forEach(toggleMenu)
			function toggleMenu(el) {
				let link = el.querySelector('.mobile-arrow-down')

				link.onclick = function () {
					const isExpanded = el.classList.contains('expanded')

					document.querySelectorAll('li.parent').forEach(li => {
						li.classList.remove('expanded')
					})

					el.classList.toggle('expanded', !isExpanded)
				}
			}
		}
	})

	// Hamburger functionality
	let hamburger = document.querySelector('header .hamburger-wrapper')
	if (hamburger) {
		let startY

		hamburger.addEventListener('click', function (e) {
			hamburger.classList.toggle('active')
			startY = window.scrollY
		})
		window.addEventListener('click', function (e) {
			if (!e.target.closest('nav') && !e.target.closest('.hamburger')) {
				hamburger.classList.remove('active')
			}
		})
		window.addEventListener('scroll', function (e) {
			if (Math.abs(window.scrollY - startY) >= 500) {
				hamburger.classList.remove('active')
			}
		})
	}

	// Helpful links functionality
	let helpfulLinks = document.querySelectorAll('.helpful-links')
	helpfulLinks.forEach(group => {
		group.addEventListener('click', e => {
			e.stopImmediatePropagation()
			group.classList.toggle('active')
		})
	})
})
